import React, { ReactNode } from 'react';
import dayjs from 'dayjs';

import DateRangeContext from '@totem/components/common/dateRangePicker/dateRangeContext';
import { PickerType } from '@totem/components/common/dateRangePicker/dateRangePickerExtended';
import { isNotNull } from '@totem/utilities/common';

type Props = {
  children?: ReactNode;
  allowClear?: boolean;
  defaultTimeFrame: PickerType;
  defaultStart?: dayjs.Dayjs;
  defaultEnd?: dayjs.Dayjs;
};

const DateRangeContainer = ({
  children,
  defaultStart,
  defaultEnd,
  allowClear,
}: Props) => {
  const [startDate, setStartDate] = React.useState<dayjs.Dayjs>(
    isNotNull(defaultStart) ? defaultStart : null,
  );
  const [endDate, setEndDate] = React.useState<dayjs.Dayjs>(
    isNotNull(defaultEnd) ? defaultEnd : null,
  );

  const handleRangeChange = (newStart: dayjs.Dayjs, newEnd: dayjs.Dayjs) => {
    setStartDate(newStart);

    setEndDate(newEnd);
  };

  return (
    <DateRangeContext.Provider
      value={{
        startDate,
        endDate,
        startDateString: isNotNull(startDate) ? startDate.toISOString() : '',
        endDateString: isNotNull(endDate) ? endDate.toISOString() : '',
        setRange: handleRangeChange,
        allowClear: isNotNull(allowClear) ? allowClear : true,
        defaultTimeFrame: 'week',
      }}
    >
      {children}
    </DateRangeContext.Provider>
  );
};

export default DateRangeContainer;
